import React, { useEffect, useState } from "react";
import { apis as api } from "../../../services/api.action";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import { cnt } from "../../../services/constant.action";
import Main from "../../layouts/Main";
import ContentTop from "../../ui-setup/ContentTop";
import RecordStatus from "../../ui-setup/RecordStatus";
import { BOM } from "../../../services/defined.action";
import appLabel from "../../../config/appLabel";
import appStatic from "../../../config/appStaticData";
import RightSide from "../../ui-setup/RightSide";
import { Tooltips } from "../../layouts/Facility";

function NewUser(props) {
  const { toolTip } = appStatic;

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const { location, userData } = props;
  const { state } = location;
  const { profileId, session, companyId } = userData;
  const [countryData, setCountryData] = useState([]);
  const [provinceData, setProvinceData] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [roleData, setRoleData] = useState([]);
  const [subRoleData, setSubRoleData] = useState([]);
  const [passwordShown, setPasswordShown] = useState(false);

  useEffect(() => {
    // console.log(props);
    getCountry();
    getRole();
    BOM.ActivateRightBtnAction("NewItemForm", "saveBtn", handleSubmit);
  }, []);

  const getCountry = () => {
    let body = {
      profileId,
      countryId: "",
      session,
    };

    BOM.FetchReqAction(body, api.GetCountry, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        setCountryData(res.countryListing);
      }
    });
  };
  const getProvince = (countryId) => {
    console.log(countryId);
    let body = {
      profileId,
      countryId,
      session,
    };
    BOM.FetchReqAction(body, api.GetCountry, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        setProvinceData(res.provinceListing);
      }
    });
  };

  const getCity = (stateId) => {
    // console.log("wow", stateId);
    let body = {
      profileId,
      stateId,
      session,
    };

    BOM.FetchReqAction(body, api.GetCity, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        //
        setCityData(res.cityListing);
      }
    });
  };

  function getRole() {
    BOM.LoadAlert(cnt.LOAD, "Processing");

    let body = {
      profileId,
      criteria: "A",
      roleId: "",
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, api.GetRole, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        setRoleData(res.roleListing);
      }
    });
  }
  const getSubRole = (parentId) => {
    BOM.LoadAlert(cnt.LOAD, "Processing");

    let getSubRoleBody = {
      profileId,
      entityId: companyId,
      parentId,
      session,
    };

    /** fetch (reqBody, url, svc, callback) */
    BOM.FetchReqAction(getSubRoleBody, api.GetSubRole, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        setSubRoleData(res.roleListing);
        // BOM.DatatableUsage();
      }
    });
  };

  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };
  const formSubmit = (formValues) => {
    // console.log("data", formValues);
    BOM.LoadAlert(cnt.LOAD, "Processing");

    /**MAKE ADJUSTMENT FOR SOME DATA*/
    formValues.firstName = BOM.Uwfirst(formValues.firstName);
    formValues.lastName = BOM.Uwfirst(formValues.lastName);
    formValues.address = BOM.Uwfirst(formValues.address);
    formValues.lang = "ENG";

    let body = {
      profileId,
      session,
      companyId,
      ...formValues,
    };

    // console.log(body);
    /** SEND REQ */
    BOM.SendReqAction(body, api.CreateUser, "/manage-user");
  };
  // return (<><p>On friday</p></>)

  return (
    <Main {...props}>
      <form
        method="POST"
        id="NewItemForm"
        autoComplete="off"
        onSubmit={handleSubmit(formSubmit, BOM.onError)}
      >
        <RightSide />
        <ContentTop pageTitle={appLabel.newUser} />
        <div className="animated fadeInRight">
          <div className="row">
            <div className="col-lg-12">
              <div className="ibox">
                <div className="ibox-title">
                  <h5>{appLabel.userInformation}</h5>
                  <div className="ibox-tools">
                    <Link to="/manage-user" className="btn btn-primary btn-xs">
                      <i className="fa fa-arrow-circle-left" />
                      &nbsp;
                      {appLabel.backBtn}
                    </Link>
                  </div>
                </div>
                <div className="ibox-content contentCard panel-primary">
                  <div className="row">
                    <div className="col-sm-3">
                      {/*left col*/}
                      <div className="text-center">
                        <img
                          src="http://ssl.gstatic.com/accounts/ui/avatar_2x.png"
                          className="avatar img-circle img-thumbnail"
                          alt="avatar"
                        />
                      </div>
                      <br />
                    </div>
                    {/*/col-3*/}
                    <div className="col-sm-9">
                      <ul className="nav nav-tabs">
                        <li className="active">
                          <a
                            data-toggle="tab"
                            href="#personalInfo"
                            target="_self"
                          >
                            <i className="fa fa-user text-navy" />
                            &nbsp;Personal
                          </a>
                        </li>
                        <li>
                          <a
                            data-toggle="tab"
                            href="#contactInfo"
                            target="_self"
                          >
                            <i className="fa fa-wechat text-navy" />
                            &nbsp;Contact
                          </a>
                        </li>
                        <li>
                          <a
                            data-toggle="tab"
                            href="#addressInfo"
                            target="_self"
                          >
                            <i className="fa fa-home text-navy" />
                            &nbsp;Address
                          </a>
                        </li>
                        <li>
                          <a data-toggle="tab" href="#roleInfo" target="_self">
                            <i className="fa fa-tag text-navy" />
                            &nbsp;Role
                          </a>
                        </li>
                      </ul>
                      <div className="tab-content">
                        <div className="tab-pane active" id="personalInfo">
                          <div className="row" style={{ marginTop: 20 }}>
                            <div className="form-group col-md-6">
                              <label className="al-subtitle">
                                {appLabel.firstName}&nbsp;
                                <Tooltips title={toolTip.firstName} />
                                <span className="asterisks">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control input-sm"
                                {...register("firstName", {
                                  required: "First Name is required !",
                                  minLength: {
                                    value: 3,
                                    message:
                                      "Name should be greater than 3 characters",
                                  },
                                })}
                                placeholder={appLabel.firstName}
                              />
                              <span className="asterisks">
                                {errors?.firstName?.message}
                              </span>
                            </div>
                            <div className="form-group col-md-6">
                              <label className="al-subtitle">
                                {appLabel.lastName}&nbsp;
                                <Tooltips title={toolTip.lastName} />
                                <span className="asterisks">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control input-sm"
                                {...register("lastName", {
                                  required: "Last Name is required !",
                                  minLength: {
                                    value: 3,
                                    message:
                                      "Name should be greater than 3 characters",
                                  },
                                })}
                                placeholder={appLabel.lastName}
                              />
                              <span className="asterisks">
                                {errors?.lastName?.message}
                              </span>
                            </div>
                            <div className="form-group col-md-6">
                              <label className="al-subtitle">
                                {appLabel.userName}&nbsp;
                                <Tooltips title={toolTip.userName} />
                                <span className="asterisks">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control input-sm"
                                {...register("userName", {
                                  required: "Username is required !",
                                  pattern: {
                                    value: /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/,
                                    message:
                                      "Email must be a valid email address !",
                                  },
                                  minLength: {
                                    value: 3,
                                    message:
                                      "Userame should be greater than 3 characters !",
                                  },
                                })}
                                placeholder={appLabel.userName}
                              />
                              <span className="asterisks">
                                {errors?.userName?.message}
                              </span>
                            </div>
                            <div className="form-group col-md-6">
                              <label className="al-subtitle">
                                {appLabel.userPassword}&nbsp;
                                <Tooltips title={toolTip.userPassword} />
                                <span className="asterisks">*</span>
                              </label>
                              <input
                                type={passwordShown ? "text" : "password"}
                                className="form-control input-sm"
                                {...register("userPswd", {
                                  required: "Password is required !",
                                  minLength: {
                                    value: 3,
                                    message:
                                      "Password should be greater than 5 characters !",
                                  },
                                })}
                                placeholder={appLabel.userPassword}
                              />
                              <span
                                className="p-viewer"
                                onClick={() => togglePassword()}
                              >
                                <i
                                  className={
                                    passwordShown
                                      ? "fa fa-eye-slash"
                                      : "fa fa-eye"
                                  }
                                ></i>
                              </span>
                              <span className="asterisks">
                                {errors?.userPswd?.message}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="tab-pane" id="contactInfo">
                          <div className="row" style={{ marginTop: 20 }}>
                            <div className="form-group col-md-6">
                              <label className="al-subtitle">
                                {appLabel.userEmail}&nbsp;
                                <Tooltips title={toolTip.userEmail} />
                                <span className="asterisks">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control input-sm"
                                placeholder={appLabel.username}
                                {...register("userEmail", {
                                  required: "Email is required!",
                                  pattern: {
                                    value: /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/,
                                    message:
                                      "Email must be a valid email address",
                                  },
                                })}
                              />
                              <span className="asterisks">
                                {errors?.userEmail?.message}
                              </span>
                            </div>
                            <div className="form-group col-md-6">
                              <label className="al-subtitle">
                                {appLabel.userPhone}&nbsp;
                                <Tooltips title={toolTip.userPhone} />
                                <span className="asterisks">*</span>
                              </label>
                              <input
                                type="number"
                                min={0}
                                className="form-control input-sm"
                                {...register("phoneNum", {
                                  required: "Phone Number is required",
                                  minLength: {
                                    value: 10,
                                    message:
                                      "Phone Number should be greater than 9 digits",
                                  },
                                  maxLength: {
                                    value: 15,
                                    message:
                                      "Phone Number should be less than 16 digits",
                                  },
                                })}
                                placeholder={appLabel.userPhone}
                              />
                              <span className="asterisks">
                                {errors?.phoneNum?.message}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="tab-pane" id="addressInfo">
                          <div className="row" style={{ marginTop: 20 }}>
                            <div className="form-group col-md-6">
                              <label className="al-subtitle">
                                {appLabel.country}&nbsp;
                                <Tooltips title={toolTip.userCountry} />
                                <span className="asterisks">*</span>
                              </label>

                              <select
                                className="form-control input-sm"
                                {...register("countryId", {
                                  required: "Country is required !",
                                  onChange: (e) => getProvince(e.target.value),
                                })}
                              >
                                <option value="">{appLabel.choose}</option>
                                {countryData.map((item, index) => (
                                  <option value={item.ID} key={index}>
                                    {item.COUNTRY_NAME}
                                  </option>
                                ))}
                              </select>
                              <span className="asterisks">
                                {errors?.countryId?.message}
                              </span>
                            </div>
                            <div className="form-group col-md-6">
                              <label className="al-subtitle">
                                {appLabel.province}&nbsp;
                                <Tooltips title={toolTip.userProvince} />
                                <span className="asterisks">*</span>
                              </label>
                              <select
                                className="form-control input-sm"
                                {...register("provinceId", {
                                  required: "Province/State is required !",
                                  onChange: (e) => getCity(e.target.value),
                                })}
                              >
                                <option value="">{appLabel.choose}</option>
                                {provinceData.map((item, index) => (
                                  <option value={item.ID} key={index}>
                                    {item.PROVINCE_NAME}
                                  </option>
                                ))}
                              </select>
                              <span className="asterisks">
                                {errors?.provinceId?.message}
                              </span>
                            </div>
                            <div className="form-group col-md-6">
                              <label className="al-subtitle">
                                {appLabel.city}&nbsp;
                                <Tooltips title={toolTip.userCity} />
                                <span className="asterisks">*</span>
                              </label>
                              <select
                                className="form-control input-sm"
                                {...register("cityId", {
                                  required: "City is required !",
                                })}
                              >
                                <option value="">{appLabel.choose}</option>
                                {cityData.map((item, index) => (
                                  <option value={item.ID} key={index}>
                                    {item.CITY_NAME}
                                  </option>
                                ))}
                              </select>
                              <span className="asterisks">
                                {errors?.cityId?.message}
                              </span>
                            </div>
                            <div className="form-group col-md-6">
                              <label className="al-subtitle">
                                {appLabel.address}&nbsp;
                                <Tooltips title={toolTip.userAddress} />
                                <span className="asterisks">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control input-sm"
                                {...register("address", {
                                  required: "Address is required !",
                                  minLength: {
                                    value: 3,
                                    message:
                                      "Address should be greater than 3 characters",
                                  },
                                })}
                                placeholder={appLabel.address}
                              />
                              <span className="asterisks">
                                {errors?.address?.message}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="tab-pane" id="roleInfo">
                          <div className="row" style={{ marginTop: 20 }}>
                            <div className="form-group col-md-6">
                              <label className="al-subtitle">
                                {appLabel.parentRoleName}&nbsp;
                                <Tooltips title={toolTip.parentRoleName} />
                                <span className="asterisks">*</span>
                              </label>
                              <select
                                className="form-control input-sm"
                                {...register("parentRoleId", {
                                  required: "Choose a parent role !",
                                  onChange: (e) => getSubRole(e.target.value),
                                })}
                              >
                                <option value="">{appLabel.choose}</option>
                                {roleData.map((item, index) => (
                                  <option value={item.ROLE_ID} key={index}>
                                    {item.ROLE_DESCRIPTION}
                                  </option>
                                ))}
                              </select>
                              <span className="asterisks">
                                {errors?.parentRoleId?.message}
                              </span>
                            </div>
                            <div className="form-group col-md-6">
                              <label className="al-subtitle">
                                {appLabel.roleName}&nbsp;
                                <Tooltips title={toolTip.roleName} />
                                <span className="asterisks">*</span>
                              </label>
                              <select
                                className="form-control input-sm"
                                {...register("roleId", {
                                  required: "Role Name is required !",
                                })}
                              >
                                <option value="">{appLabel.choose}</option>
                                {subRoleData.map((item, index) => (
                                  <option value={item.ROLE_ID} key={index}>
                                    {item.ROLE_NAME}
                                  </option>
                                ))}
                              </select>
                              <span className="asterisks">
                                {errors?.roleId?.message}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/*/tab-content*/}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <RecordStatus {...BOM.NewRecordStatusdata()} />
        </div>
      </form>
    </Main>
  );
}

const mapStateToProps = (state) => ({
  userData: state.auth.userData,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(NewUser);
